import { action, observable } from "mobx";

import MainEntity from "domain/main/MainEntity";

/**
 * [공통관리] 기업사업자 등록증 Entity
 */
export default abstract class TbCommCorpBizLicEntity extends MainEntity {
  @observable protected bizNo: string = "";
  @observable protected regDate!: Date;
  @observable protected fileId: string = "";
  @observable protected lstYn: string = "";
  @observable protected regUserid: string = "";

  public getBizNo(): string {
    return this.bizNo;
  }

  @action
  public setBizNo(bizNo: string): void {
    this.bizNo = bizNo;
  }

  public getRegDate(): Date {
    return this.regDate;
  }

  @action
  public setRegDate(regDate: Date): void {
    this.regDate = regDate;
  }

  public getFileId(): string {
    return this.fileId;
  }

  @action
  public setFileId(fileId: string): void {
    this.fileId = fileId;
  }

  public getLstYn(): string {
    return this.lstYn;
  }

  @action
  public setLstYn(lstYn: string): void {
    this.lstYn = lstYn;
  }

  public getRegUserid(): string {
    return this.regUserid;
  }

  @action
  public setRegUserid(regUserid: string): void {
    this.regUserid = regUserid;
  }
}
